'use strict';
import modalRechazoController from './modal_input/pagorechazo.modal.obs.controller.js';
import modalRechazoTemplate from './modal_input/pagorechazo.modal.obs.html';

class ImpresionProdController {
  constructor($log, Modal, Storage, DataService, Message, $location,$window, Loading) {
    'ngInject';
    this.$log = $log;
    this.Modal = Modal;
    this.Storage = Storage;
    this.DataService = DataService;
    this.$location = $location;
    this.$window = $window;
    this.Message = Message;
    this.Loading = Loading;
  }

  $onInit() {
    this.Loading.show('Cargando', true);

    this.solicitud = this.Storage.get('print_prod');
    this.requiredFields = true;
    this.ddjjPdf = null;

    const url = 'certificacion_promueve/' + this.solicitud.id_unidad_productiva + '/certificacion/' + this.solicitud.id_producto + '/ddjj_pdf';
    this.DataService.pdfO(url, {}).then((response) => {
      if (response) {
        this.ddjjPdf = response;
        this.$log.log("FINALIZADO");
      }
      this.Loading.hide();
    });
  }

  atras() {
    this.$location.path('certificaciones');
  }

  imprimir(producto)
  {
    var printwWindow = this.$window.open(producto.pdf_certificado);
    printwWindow.print();

    var this_ = this;
    setTimeout(function()
    {
      this_.confirmarImpresion(producto);
    }, 2000);
  }

  confirmarImpresion(cert) {
    var this_ = this;
    this.Modal.confirm('¿La impresión se realizó correctamente?',function()
    {
      this_.$log.log('---Realizamos la aprobacion');
      var obj = {
        id_producto: cert.certificacion.producto.id_producto
      };

      this_.DataService.put('certificacion_promueve/'+this_.solicitud.unidad_productiva.id_unidad_productiva+'/producto/imprimir_certificado', obj)
        .then(response => {
          if (response) {
            cert.certificacion.impreso = true;
          }
        });
    },
    null,
    "Confirmar impresión",
    "SI",
    "NO",
    "print");
  }

  // Deprecado: 18/02/2022
  registrarFactura_deprecated(form){
    if (form.$valid) {
      var this_ = this;
      const productos = [];
      let id_certificacion = null;
      if (this_.solicitud.certificaciones_pagos.length > 0) {
        this_.solicitud.certificaciones_pagos.forEach(certificacion => {
          productos.push(certificacion.certificacion.producto.id_producto)
          id_certificacion = certificacion.fid_certificacion;
        })
      }
      var obj=
      {
        nro_autorizacion:this.numero_autorizacion,
        nro_factura:this.numero_factura,
        fecha_factura:this.fecha_factura,
        codigo_control:this.codigo_control,
        nit:this.solicitud.unidad_productiva.nit,
        id_pago:this.solicitud.id_pago,
        productos,
        id_certificacion,
      };
      this_.DataService.put('certificacion_promueve/pagos/finalizar', obj)
        .then(response => {
          if (response) {
            this_.$location.path('certificaciones');
          }
        });
    } else {
      form.$setSubmitted();
    }
  }

  aprobar(form) {
    this.requiredFields = true;
    if (form.$valid && this.numero_autorizacion && this.numero_factura && this.fecha_factura) {
      this.Modal.confirm('¿Está seguro/a de aprobar la solicitud?', () => {
        var this_ = this;
        let id_certificacion = this.getIdCertificacion();

        if (id_certificacion) {
          const obj = {
            nro_autorizacion:this.numero_autorizacion,
            nro_factura:this.numero_factura,
            fecha_factura:this.fecha_factura,
            nit:this.solicitud.nit,
            id_pago:this.solicitud.id_pago,
            id_certificacion,
          };
          this_.DataService.put('certificacion_promueve/pagos/finalizar', obj)
            .then(response => {
              if (response) {
                this.Message.success('La certificación ha sido aprobado satisfactoriamente', 'información');
                this_.$location.path('certificaciones');
              }
            });
        } else {
          this.Message.error('No es posible identificar a la certificación actual');
        }
      });
    } else {
      form.$setSubmitted();
    }
  }

  rechazar() {
    this.requiredFields = false;
    this.Modal.show({
      template: modalRechazoTemplate,
      controller: modalRechazoController,
      data: {
        prefijo: 'rechazar',
        titulo: "Rechazar",
        accion: "RECHAZADO",
        detalle_campo: "Ingresar el motivo por el cual se rechaza la solicitud de certificación",
        id_pago: this.solicitud.id_pago,
        id_certificacion: this.getIdCertificacion(),
      },
      size: 'lg'
    });
  }

  getIdCertificacion () {
    return this.solicitud.id_certificacion;
  }

}

export default ImpresionProdController;



// WEBPACK FOOTER //
// ./src/app/components/admin/promueve/impresion/impresion_prom.controller.js